(function (a, b) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = b() : 'function' == typeof define && define.amd ? define([], b) : 'object' == typeof exports ? exports.redshift = b() : a.redshift = b();
})('undefined' == typeof self ? this : self, function () {
  return function (a) {
    function b(d) {
      if (c[d]) return c[d].exports;
      var e = c[d] = {
        i: d,
        l: !1,
        exports: {}
      };
      return a[d].call(e.exports, e, e.exports, b), e.l = !0, e.exports;
    }

    var c = {};
    return b.m = a, b.c = c, b.d = function (a, c, d) {
      b.o(a, c) || Object.defineProperty(a, c, {
        enumerable: !0,
        get: d
      });
    }, b.r = function (a) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, {
        value: 'Module'
      }), Object.defineProperty(a, '__esModule', {
        value: !0
      });
    }, b.t = function (a, c) {
      if (1 & c && (a = b(a)), 8 & c) return a;
      if (4 & c && 'object' == typeof a && a && a.__esModule) return a;
      var d = Object.create(null);
      if (b.r(d), Object.defineProperty(d, 'default', {
        enumerable: !0,
        value: a
      }), 2 & c && 'string' != typeof a) for (var e in a) {
        b.d(d, e, function (b) {
          return a[b];
        }.bind(null, e));
      }
      return d;
    }, b.n = function (a) {
      var c = a && a.__esModule ? function () {
        return a['default'];
      } : function () {
        return a;
      };
      return b.d(c, 'a', c), c;
    }, b.o = function (a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }, b.p = '', b(b.s = 6);
  }([function (a) {
    a.exports = require('@xcmats/js-toolbox');
  }, function (a) {
    a.exports = require('bip39');
  }, function (a, b) {
    'use strict';

    var c,
        d,
        e = Math.pow,
        f = Math.floor,
        g = {
      cipher: {},
      hash: {},
      keyexchange: {},
      mode: {},
      misc: {},
      codec: {},
      exception: {
        corrupt: function corrupt(a) {
          this.toString = function () {
            return 'CORRUPT: ' + this.message;
          }, this.message = a;
        },
        invalid: function invalid(a) {
          this.toString = function () {
            return 'INVALID: ' + this.message;
          }, this.message = a;
        },
        bug: function bug(a) {
          this.toString = function () {
            return 'BUG: ' + this.message;
          }, this.message = a;
        },
        notReady: function notReady(a) {
          this.toString = function () {
            return 'NOT READY: ' + this.message;
          }, this.message = a;
        }
      }
    };
    g.bitArray = {
      bitSlice: function bitSlice(b, a, c) {
        return b = g.bitArray._shiftRight(b.slice(a / 32), 32 - (31 & a)).slice(1), void 0 === c ? b : g.bitArray.clamp(b, c - a);
      },
      extract: function extract(b, a, c) {
        var d,
            e = f(31 & -a - c);
        return d = -32 & (a + c - 1 ^ a) ? b[0 | a / 32] << 32 - e ^ b[0 | a / 32 + 1] >>> e : b[0 | a / 32] >>> e, d & (1 << c) - 1;
      },
      concat: function concat(a, b) {
        if (0 === a.length || 0 === b.length) return a.concat(b);
        var c = a[a.length - 1],
            d = g.bitArray.getPartial(c);
        return 32 === d ? a.concat(b) : g.bitArray._shiftRight(b, d, 0 | c, a.slice(0, a.length - 1));
      },
      bitLength: function bitLength(b) {
        var a,
            c = b.length;
        return 0 === c ? 0 : (a = b[c - 1], 32 * (c - 1) + g.bitArray.getPartial(a));
      },
      clamp: function clamp(b, a) {
        if (32 * b.length < a) return b;
        b = b.slice(0, Math.ceil(a / 32));
        var c = b.length;
        return a &= 31, 0 < c && a && (b[c - 1] = g.bitArray.partial(a, b[c - 1] & 2147483648 >> a - 1, 1)), b;
      },
      partial: function partial(a, b, c) {
        return 32 === a ? b : (c ? 0 | b : b << 32 - a) + 1099511627776 * a;
      },
      getPartial: function getPartial(a) {
        return Math.round(a / 1099511627776) || 32;
      },
      equal: function equal(c, a) {
        if (g.bitArray.bitLength(c) !== g.bitArray.bitLength(a)) return !1;
        var b,
            d = 0;

        for (b = 0; b < c.length; b++) {
          d |= c[b] ^ a[b];
        }

        return 0 == d;
      },
      _shiftRight: function _shiftRight(b, a, c, d) {
        var e,
            f,
            h = 0;

        for (void 0 === d && (d = []); 32 <= a; a -= 32) {
          d.push(c), c = 0;
        }

        if (0 === a) return d.concat(b);

        for (e = 0; e < b.length; e++) {
          d.push(c | b[e] >>> a), c = b[e] << 32 - a;
        }

        return h = b.length ? b[b.length - 1] : 0, f = g.bitArray.getPartial(h), d.push(g.bitArray.partial(31 & a + f, 32 < a + f ? c : d.pop(), 1)), d;
      },
      _xor4: function _xor4(a, b) {
        return [a[0] ^ b[0], a[1] ^ b[1], a[2] ^ b[2], a[3] ^ b[3]];
      },
      byteswapM: function byteswapM(b) {
        var a,
            c,
            d = 65280;

        for (a = 0; a < b.length; ++a) {
          c = b[a], b[a] = c >>> 24 | c >>> 8 & d | (c & d) << 8 | c << 24;
        }

        return b;
      }
    }, g.codec.utf8String = {
      fromBits: function fromBits(a) {
        var b,
            c,
            d = '',
            e = g.bitArray.bitLength(a);

        for (b = 0; b < e / 8; b++) {
          0 == (3 & b) && (c = a[b / 4]), d += String.fromCharCode(c >>> 8 >>> 8 >>> 8), c <<= 8;
        }

        return decodeURIComponent(escape(d));
      },
      toBits: function toBits(a) {
        a = unescape(encodeURIComponent(a));
        var b,
            c = [],
            d = 0;

        for (b = 0; b < a.length; b++) {
          d = d << 8 | a.charCodeAt(b), 3 == (3 & b) && (c.push(d), d = 0);
        }

        return 3 & b && c.push(g.bitArray.partial(8 * (3 & b), d)), c;
      }
    }, g.codec.hex = {
      fromBits: function fromBits(a) {
        var b,
            c = '';

        for (b = 0; b < a.length; b++) {
          c += ((0 | a[b]) + 0xF00000000000).toString(16).substr(4);
        }

        return c.substr(0, g.bitArray.bitLength(a) / 4);
      },
      toBits: function toBits(a) {
        var b,
            c,
            d = [];

        for (a = a.replace(/\s|0x/g, ''), c = a.length, a += '00000000', b = 0; b < a.length; b += 8) {
          d.push(0 ^ parseInt(a.substr(b, 8), 16));
        }

        return g.bitArray.clamp(d, 4 * c);
      }
    }, g.hash.sha256 = function (a) {
      this._key[0] || this._precompute(), a ? (this._h = a._h.slice(0), this._buffer = a._buffer.slice(0), this._length = a._length) : this.reset();
    }, g.hash.sha256.hash = function (a) {
      return new g.hash.sha256().update(a).finalize();
    }, g.hash.sha256.prototype = {
      blockSize: 512,
      reset: function reset() {
        return this._h = this._init.slice(0), this._buffer = [], this._length = 0, this;
      },
      update: function update(a) {
        'string' == typeof a && (a = g.codec.utf8String.toBits(a));
        var d,
            e = this._buffer = g.bitArray.concat(this._buffer, a),
            b = this._length,
            f = this._length = b + g.bitArray.bitLength(a);
        if (9007199254740991 < f) throw new g.exception.invalid('Cannot hash more than 2^53 - 1 bits');

        if ('undefined' != typeof Uint32Array) {
          var h = new Uint32Array(e),
              c = 0;

          for (d = 512 + b - (511 & 512 + b); d <= f; d += 512) {
            this._block(h.subarray(16 * c, 16 * (c + 1))), c += 1;
          }

          e.splice(0, 16 * c);
        } else for (d = 512 + b - (511 & 512 + b); d <= f; d += 512) {
          this._block(e.splice(0, 16));
        }

        return this;
      },
      finalize: function finalize() {
        var a,
            c = this._buffer,
            b = this._h;

        for (c = g.bitArray.concat(c, [g.bitArray.partial(1, 1)]), a = c.length + 2; 15 & a; a++) {
          c.push(0);
        }

        for (c.push(f(this._length / 4294967296)), c.push(0 | this._length); c.length;) {
          this._block(c.splice(0, 16));
        }

        return this.reset(), b;
      },
      _init: [],
      _key: [],
      _precompute: function _precompute() {
        function a(a) {
          return 0 | 4294967296 * (a - f(a));
        }

        for (var b, c, d = 0, g = 2; 64 > d; g++) {
          for (c = !0, b = 2; b * b <= g; b++) {
            if (0 == g % b) {
              c = !1;
              break;
            }
          }

          c && (8 > d && (this._init[d] = a(e(g, 1 / 2))), this._key[d] = a(e(g, 1 / 3)), d++);
        }
      },
      _block: function _block(c) {
        var d,
            e,
            f,
            a,
            b = this._h,
            g = this._key,
            h = b[0],
            i = b[1],
            j = b[2],
            k = b[3],
            l = b[4],
            m = b[5],
            n = b[6],
            o = b[7];

        for (d = 0; 64 > d; d++) {
          16 > d ? e = c[d] : (f = c[15 & d + 1], a = c[15 & d + 14], e = c[15 & d] = 0 | (f >>> 7 ^ f >>> 18 ^ f >>> 3 ^ f << 25 ^ f << 14) + (a >>> 17 ^ a >>> 19 ^ a >>> 10 ^ a << 15 ^ a << 13) + c[15 & d] + c[15 & d + 9]), e = e + o + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (n ^ l & (m ^ n)) + g[d], o = n, n = m, m = l, l = 0 | k + e, k = j, j = i, i = h, h = 0 | e + (i & j ^ k & (i ^ j)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10);
        }

        b[0] = 0 | b[0] + h, b[1] = 0 | b[1] + i, b[2] = 0 | b[2] + j, b[3] = 0 | b[3] + k, b[4] = 0 | b[4] + l, b[5] = 0 | b[5] + m, b[6] = 0 | b[6] + n, b[7] = 0 | b[7] + o;
      }
    }, g.hash.sha512 = function (a) {
      this._key[0] || this._precompute(), a ? (this._h = a._h.slice(0), this._buffer = a._buffer.slice(0), this._length = a._length) : this.reset();
    }, g.hash.sha512.hash = function (a) {
      return new g.hash.sha512().update(a).finalize();
    }, g.hash.sha512.prototype = {
      blockSize: 1024,
      reset: function reset() {
        return this._h = this._init.slice(0), this._buffer = [], this._length = 0, this;
      },
      update: function update(a) {
        'string' == typeof a && (a = g.codec.utf8String.toBits(a));
        var d,
            e = this._buffer = g.bitArray.concat(this._buffer, a),
            b = this._length,
            f = this._length = b + g.bitArray.bitLength(a);
        if (9007199254740991 < f) throw new g.exception.invalid('Cannot hash more than 2^53 - 1 bits');

        if ('undefined' != typeof Uint32Array) {
          var h = new Uint32Array(e),
              c = 0;

          for (d = 1024 + b - (1023 & 1024 + b); d <= f; d += 1024) {
            this._block(h.subarray(32 * c, 32 * (c + 1))), c += 1;
          }

          e.splice(0, 32 * c);
        } else for (d = 1024 + b - (1023 & 1024 + b); d <= f; d += 1024) {
          this._block(e.splice(0, 32));
        }

        return this;
      },
      finalize: function finalize() {
        var a,
            c = this._buffer,
            b = this._h;

        for (c = g.bitArray.concat(c, [g.bitArray.partial(1, 1)]), a = c.length + 4; 31 & a; a++) {
          c.push(0);
        }

        for (c.push(0), c.push(0), c.push(f(this._length / 4294967296)), c.push(0 | this._length); c.length;) {
          this._block(c.splice(0, 32));
        }

        return this.reset(), b;
      },
      _init: [],
      _initr: [12372232, 13281083, 9762859, 1914609, 15106769, 4090911, 4308331, 8266105],
      _key: [],
      _keyr: [2666018, 15689165, 5061423, 9034684, 4764984, 380953, 1658779, 7176472, 197186, 7368638, 14987916, 16757986, 8096111, 1480369, 13046325, 6891156, 15813330, 5187043, 9229749, 11312229, 2818677, 10937475, 4324308, 1135541, 6741931, 11809296, 16458047, 15666916, 11046850, 698149, 229999, 945776, 13774844, 2541862, 12856045, 9810911, 11494366, 7844520, 15576806, 8533307, 15795044, 4337665, 16291729, 5553712, 15684120, 6662416, 7413802, 12308920, 13816008, 4303699, 9366425, 10176680, 13195875, 4295371, 6546291, 11712675, 15708924, 1519456, 15772530, 6568428, 6495784, 8568297, 13007125, 7492395, 2515356, 12632583, 14740254, 7262584, 1535930, 13146278, 16321966, 1853211, 294276, 13051027, 13221564, 1051980, 4080310, 6651434, 14088940, 4675607],
      _precompute: function _precompute() {
        function a(a) {
          return 0 | 4294967296 * (a - f(a));
        }

        function b(a) {
          return 255 & 1099511627776 * (a - f(a));
        }

        for (var c, d, g = 0, h = 2; 80 > g; h++) {
          for (d = !0, c = 2; c * c <= h; c++) {
            if (0 == h % c) {
              d = !1;
              break;
            }
          }

          d && (8 > g && (this._init[2 * g] = a(e(h, 1 / 2)), this._init[2 * g + 1] = b(e(h, 1 / 2)) << 24 | this._initr[g]), this._key[2 * g] = a(e(h, 1 / 3)), this._key[2 * g + 1] = b(e(h, 1 / 3)) << 24 | this._keyr[g], g++);
        }
      },
      _block: function _block(a) {
        var b,
            c,
            d,
            e,
            f = this._h,
            g = this._key,
            h = f[0],
            i = f[1],
            k = f[2],
            l = f[3],
            m = f[4],
            n = f[5],
            o = f[6],
            p = f[7],
            q = f[8],
            r = f[9],
            s = f[10],
            t = f[11],
            u = f[12],
            v = f[13],
            w = f[14],
            x = f[15];

        if ('undefined' != typeof Uint32Array) {
          e = Array(160);

          for (var y = 0; 32 > y; y++) {
            e[y] = a[y];
          }
        } else e = a;

        var j = h,
            z = i,
            A = k,
            B = l,
            C = m,
            D = n,
            E = o,
            F = p,
            G = q,
            H = r,
            I = s,
            J = t,
            K = u,
            L = v,
            M = w,
            N = x;

        for (b = 0; 80 > b; b++) {
          if (16 > b) c = e[2 * b], d = e[2 * b + 1];else {
            var O = e[2 * (b - 15)],
                P = e[2 * (b - 15) + 1],
                Q = (O << 31 | P >>> 1) ^ (O << 24 | P >>> 8) ^ (O << 25 | P >>> 7),
                R = e[2 * (b - 2)],
                S = e[2 * (b - 2) + 1],
                T = (R << 13 | S >>> 19) ^ (S << 3 | R >>> 29) ^ (R << 26 | S >>> 6),
                U = e[2 * (b - 7)],
                V = e[2 * (b - 7) + 1],
                W = e[2 * (b - 16)],
                X = e[2 * (b - 16) + 1];
            d = Q + V, c = ((P << 31 | O >>> 1) ^ (P << 24 | O >>> 8) ^ O >>> 7) + U + (d >>> 0 < Q >>> 0 ? 1 : 0), d += T, c += ((S << 13 | R >>> 19) ^ (R << 3 | S >>> 29) ^ R >>> 6) + (d >>> 0 < T >>> 0 ? 1 : 0), d += X, c += W + (d >>> 0 < X >>> 0 ? 1 : 0);
          }
          e[2 * b] = c |= 0, e[2 * b + 1] = d |= 0;

          var Y = G & I ^ ~G & K,
              Z = H & J ^ ~H & L,
              $ = j & A ^ j & C ^ A & C,
              _ = z & B ^ z & D ^ B & D,
              aa = (z << 4 | j >>> 28) ^ (j << 30 | z >>> 2) ^ (j << 25 | z >>> 7),
              ba = (j << 4 | z >>> 28) ^ (z << 30 | j >>> 2) ^ (z << 25 | j >>> 7),
              ca = (H << 18 | G >>> 14) ^ (H << 14 | G >>> 18) ^ (G << 23 | H >>> 9),
              da = (G << 18 | H >>> 14) ^ (G << 14 | H >>> 18) ^ (H << 23 | G >>> 9),
              ea = g[2 * b],
              fa = g[2 * b + 1],
              ga = N + da,
              ha = M + ca + (ga >>> 0 < N >>> 0 ? 1 : 0);

          ga += Z, ha += Y + (ga >>> 0 < Z >>> 0 ? 1 : 0), ga += fa, ha += ea + (ga >>> 0 < fa >>> 0 ? 1 : 0), ga = 0 | ga + d, ha += c + (ga >>> 0 < d >>> 0 ? 1 : 0);
          var ia = ba + _,
              ja = aa + $ + (ia >>> 0 < ba >>> 0 ? 1 : 0);
          M = K, N = L, K = I, L = J, I = G, J = H, H = 0 | F + ga, G = 0 | E + ha + (H >>> 0 < F >>> 0 ? 1 : 0), E = C, F = D, C = A, D = B, A = j, B = z, z = 0 | ga + ia, j = 0 | ha + ja + (z >>> 0 < ga >>> 0 ? 1 : 0);
        }

        i = f[1] = 0 | i + z, f[0] = 0 | h + j + (i >>> 0 < z >>> 0 ? 1 : 0), l = f[3] = 0 | l + B, f[2] = 0 | k + A + (l >>> 0 < B >>> 0 ? 1 : 0), n = f[5] = 0 | n + D, f[4] = 0 | m + C + (n >>> 0 < D >>> 0 ? 1 : 0), p = f[7] = 0 | p + F, f[6] = 0 | o + E + (p >>> 0 < F >>> 0 ? 1 : 0), r = f[9] = 0 | r + H, f[8] = 0 | q + G + (r >>> 0 < H >>> 0 ? 1 : 0), t = f[11] = 0 | t + J, f[10] = 0 | s + I + (t >>> 0 < J >>> 0 ? 1 : 0), v = f[13] = 0 | v + L, f[12] = 0 | u + K + (v >>> 0 < L >>> 0 ? 1 : 0), x = f[15] = 0 | x + N, f[14] = 0 | w + M + (x >>> 0 < N >>> 0 ? 1 : 0);
      }
    }, g.misc.hmac = function (a, b) {
      this._hash = b = b || g.hash.sha256;
      var c,
          d = [[], []],
          e = b.prototype.blockSize / 32;

      for (this._baseHash = [new b(), new b()], a.length > e && (a = b.hash(a)), c = 0; c < e; c++) {
        d[0][c] = 909522486 ^ a[c], d[1][c] = 1549556828 ^ a[c];
      }

      this._baseHash[0].update(d[0]), this._baseHash[1].update(d[1]), this._resultHash = new b(this._baseHash[0]);
    }, g.misc.hmac.prototype.encrypt = g.misc.hmac.prototype.mac = function (a) {
      if (!this._updated) return this.update(a), this.digest(a);
      throw new g.exception.invalid('encrypt on already updated hmac called!');
    }, g.misc.hmac.prototype.reset = function () {
      this._resultHash = new this._hash(this._baseHash[0]), this._updated = !1;
    }, g.misc.hmac.prototype.update = function (a) {
      this._updated = !0, this._resultHash.update(a);
    }, g.misc.hmac.prototype.digest = function () {
      var a = this._resultHash.finalize(),
          b = new this._hash(this._baseHash[1]).update(a).finalize();

      return this.reset(), b;
    }, a.exports && (a.exports = g), c = [], d = function () {
      return g;
    }.apply(b, c), !(d !== void 0 && (a.exports = d));
  }, function (a) {
    a.exports = require('@babel/runtime/helpers/typeof');
  }, function (a) {
    a.exports = {
      a: '1.0.4'
    };
  }, function (a) {
    a.exports = require('stellar-sdk');
  }, function (a, b, c) {
    'use strict';

    c.r(b), c.d(b, 'ENTROPY', function () {
      return p;
    }), c.d(b, 'LANGUAGE', function () {
      return q;
    }), c.d(b, 'genMnemonic', function () {
      return r;
    }), c.d(b, 'validateMnemonic', function () {
      return s;
    }), c.d(b, 'genKeypair', function () {
      return t;
    }), c.d(b, 'newAddress', function () {
      return u;
    }), c.d(b, 'restoreAddress', function () {
      return v;
    }), c.d(b, 'words', function () {
      return w;
    });
    var d = c(3),
        e = c.n(d),
        f = c(1),
        g = c.n(f),
        h = c(0),
        i = c.n(h),
        j = c(2),
        k = c.n(j),
        l = c(5),
        m = c.n(l);
    c.d(b, 'mnemonicToSeedHex', function () {
      return f.mnemonicToSeedHex;
    });
    var n = c(4),
        o = c.t(4, 1);
    c.d(b, 'version', function () {
      return n.a;
    });

    var p = Object.freeze({
      HIGH: 256,
      MEDIUM: 128
    }),
        q = Object.freeze({
      CN: 'chinese_simplified',
      CT: 'chinese_traditional',
      EN: 'english',
      FR: 'french',
      IT: 'italian',
      JP: 'japanese',
      KR: 'korean',
      SP: 'spanish'
    }),
        r = function r() {
      var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : q.EN,
          b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : p.HIGH;
      return h.func.rearg(f.generateMnemonic)(0, 2)(b, f.wordlists[a]);
    },
        s = function s(a) {
      var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : q.EN;
      return Object(f.validateMnemonic)(a, f.wordlists[b]);
    },
        t = function t(a) {
      var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 0,
          c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {},
          d = c.Keypair,
          f = void 0 === d ? l.Keypair : d;
      if (!h.type.isString(a) || !h.type.isNumber(b)) throw new TypeError('redshift.genKeypair() expected [string] and [number], ' + 'got ['.concat(e()(a), '] and [').concat(e()(b), ']'));

      var g = function g(a, b) {
        return new j.misc.hmac(a, j.hash.sha512).encrypt(b);
      };

      return h.func.pipe([44, 148, b].reduce(function (a, b) {
        return g(h.array.drop(8)(a), [j.codec.hex.toBits('0x00'), h.array.take(8)(a), j.codec.hex.toBits((2147483648 + b).toString(16))].reduce(j.bitArray.concat, []));
      }, g(j.codec.utf8String.toBits('ed25519 seed'), j.codec.hex.toBits(a))))(h.array.take(8), j.codec.hex.fromBits, h.codec.hexToBytes, f.fromRawEd25519Seed.bind(f));
    },
        u = function u() {
      var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : h.string.empty(),
          b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 0,
          c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : q.EN,
          d = 3 < arguments.length ? arguments[3] : void 0;
      if (!h.type.isString(a) || !h.type.isNumber(b)) throw new TypeError('redshift.newAddress(): wrong argument types');
      var e = r(c),
          g = Object(f.mnemonicToSeedHex)(e, a),
          i = t(g, b, d);
      return {
        mnemonic: e,
        passphrase: a,
        account: b,
        seed: g,
        keypair: i
      };
    },
        v = function v(a) {
      var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : h.string.empty(),
          c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 0,
          d = 3 < arguments.length ? arguments[3] : void 0;
      if (!h.type.isString(a) || !h.type.isString(b) || !h.type.isNumber(c)) throw new TypeError('redshift.restoreAddress(): wrong argument types');
      var e = Object(f.mnemonicToSeedHex)(a, b),
          g = t(e, c, d);
      return {
        mnemonic: a,
        passphrase: b,
        account: c,
        seed: e,
        keypair: g
      };
    },
        w = function w() {
      var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : q.EN;
      return f.wordlists[a];
    };
  }]);
});